module.exports = __webpack_public_path__ + "static/img/son5_active.2af6a869.png";